@if (!this.needToInputCode) {
  <div
    class="w-full h-full flex flex-col p-3 gap-3 bg-gris-3 overflow-y-scroll">
    <div
      class="w-full p-3 flex flex-col items-center justify-center choose-restaurant text-white rounded-xl relative mt-4 px-6">
      <p class="font-semibold text-2xl z-20 text-center w-full">Sélectionnez un restaurant</p>
      <div class="flex items-center rounded overflow-hidden search-wrapper z-20 w-full">
        <div class="w-12 h-12 bg-white ml-auto flex items-center justify-center">
          <span class="material-icons  text-black block">search</span>
        </div>

        <input (keyup)="this.searchForRestaurant($event)"
               class="p-2 text-black h-12 text-sm min-w-48 text-center font-semibold z-20 w-full max-w-96 mr-auto border-none focus:ring-0 bg-white"
               placeholder="Rechercher un restaurant"
               type="text">
      </div>
      <!-- Image optimisée avec dimension explicites et chargement prioritaire -->
      <img alt="Chef" width="300" height="400" fetchpriority="high"
           class="absolute left-0 bottom-0" src="/assets/images/humans/chef-smiling.webp"
           style="transform: scale(1.1) translateY(-5%); z-index: 0;">
    </div>
    <div class="bg-blanc rounded-xl w-full flex-1 py-3 pb-32">
      @if (this.isDedicated && this.customerUseCode) {
        <button
          class="my-2 mx-auto flex items-center rounded border border-gris-3 px-2 py-1 gap-2 hover:bg-gris-3 transition"
          (click)="this.clearCode()">
          <span class="material-icons">refresh</span>
          <span class="text-sm font-medium">Changer de code</span>
        </button>
      }
      @if (this.restaurants.length > 0) {
        <p class="w-full text-center">
          <span class="font-semibold">Résultat : {{ this.getRestaurantsFiltered().length }}</span>
          <span> restaurant(s) disponible(s) !</span>
        </p>
      }
      <!-- Reste du contenu avec lazy loading pour les images -->
      <div class="w-full flex flex-wrap justify-center p-3 gap-2 overflow-y-auto">
        @for (restaurant of this.getRestaurantsFiltered(); track restaurant; let index = $index) {
          <div (click)="this.selectRestaurant($event, restaurant)"
               class="rounded border border-gris-3 flex flex-col rounded overflow-hidden w-1/5 min-w-72 restaurant cursor-pointer">
            <div [class.bg-orange-1]="index % 2 !== 0" [class.rest-back-image]="true"
                 class="h-[150px] w-full flex items-center justify-center relative">
              <div class="w-full h-full absolute"></div>
              <!-- Images avec lazy loading -->
              <img [attr.src]="this.genereateImageUrl(restaurant)"
                   loading="lazy" width="128" height="128"
                   alt="Image du restaurant" class="rounded-full w-32 h-32 object-contain z-10">
            </div>
            <p class="font-semibold w-full text-center p-2">{{ restaurant.name }}</p>
            <p class="fg-gris-1 max-w-72 font-medium text-sm p-2 px-3">
              {{ restaurant.address }} <br/>
              {{ restaurant.postal_code }} - {{ restaurant.city }}
            </p>
            <div class="w-full flex items-stretch justify-center gap-1 p-1 restaurants mt-auto">
              <mk-icon-button (click)="this.showRestaurantInfos(restaurant)" [fullscale]="true" [height]="40"
                              class="flex-1"
                              icon="keyboard_arrow_right" label="En savoir plus" style="font-size: 11px;"
                              useSvg="false"/>
              <mk-icon-button (click)="this.selectRestaurant(null, restaurant)" [fullscale]="true" [height]="40"
                              class="flex-1"
                              icon="keyboard_arrow_right" label="Choisir" style="font-size: 11px;" type="primary"
                              useSvg="false"/>
            </div>
          </div>
        }
        <!-- Indicateur de chargement -->
        @if (this.loadingRestaurants && this.restaurants.length === 0) {
          <div
            class="font-semibold text-gray-700 flex items-center justify-center gap-2 bg-gray-200 border border-gray-700 rounded p-3 pr-5">
            <span class="material-icons animate-spin">autorenew</span>
            <p>Chargement de la liste des restaurants...</p>
          </div>
        }
      </div>
    </div>
  </div>
}

@if (this.needToInputCode && !this.isVerifyingCode) {
  <div
    class="w-full h-full overflow-none pb-32 md:pb-2 p-2 flex justify-center items-center bg-gris-4 z-20">
    <div class="bg-white p-4 text-black rounded border border-gris-3 fg-noir-2">
      <div class="w-full flex items-center justify-center gap-2 fg-orange-1">
                  <span class="material-icons">
                    lock
                  </span>
        <p class="font-bold">Code d'accès requis</p>
      </div>
      <p class="mb-0 font-medium mt-4">
        L'accès à la liste des établissement est <b class="fg-vert-1">protégé</b> par un <b class="fg-vert-1">code
        d'accès</b>.
      </p>
      <p class="font-bold mt-2 fg-noir-2 text-center w-full">
        La liste sera différente selon le code renseigné.
      </p>
      <input (keydown.enter)="this.verifyInputCode()" [(ngModel)]="this.inputCode"
             class="border w-full rounded py-2 px-2 border-gris-3 bg-white" name="restaurantCode"
             placeholder="Code d'accès" style="-webkit-text-security: disc;" type="text">
      <mk-icon-button (click)="this.verifyInputCode()" [height]="40"
                      [icon]="this.errorMessage !== '' ? 'error' : 'key'"
                      [label]="this.errorMessage !== '' ? this.errorMessage : 'Accéder à la liste'"
                      [type]="this.errorMessage !== '' ? 'dark' : 'primary'" class="w-full mt-4"
                      useSvg="false"/>
    </div>
  </div>
}

